module.exports = __webpack_public_path__ + "img/product1.ea9d1986.jpg";